import { useQuery } from '@tanstack/react-query';
import { getFooterPartners, getFooterPaymentMethods } from './api';

export const useFooterPartner = () => {
    return useQuery(['footer-partners'], () => getFooterPartners(), {
        staleTime: Infinity,
        cacheTime: Infinity
    });
};

export const useFooterPaymentMethods = () => {
    return useQuery(['footer-payment-methods'], () => getFooterPaymentMethods(), {
        staleTime: Infinity,
        cacheTime: Infinity
    });
};
